import script from "./BalTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTable.vue?vue&type=script&setup=true&lang=ts"

import "./BalTable.vue?vue&type=style&index=0&id=3c3034e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3034e4"]])

export default __exports__